import { createAction } from 'typesafe-actions';
import { ActionTypes } from '../types';

export const switchMode = createAction(ActionTypes.SWITCH_MODE)<'light' | 'dark'>();
